
import { MqMinWidthTabletXlarge } from '@Tokens/tokens.json';
import { buildFixedSrcSet, buildSrc } from '@Utils/images';

const variants = [1, 2, 3];

export default {
  name: 'EditoBanner',
  props: {
    /**
     * Badge text
     */
    badge: {
      type: String,
      default: undefined,
    },
    /**
     * Background image
     */
    img: {
      type: [Object, String],
      default: undefined,
    },
    /**
     * Title text
     */
    title: {
      type: String,
      default: undefined,
    },
    /**
     * theme variant
     */
    variant: {
      type: Number,
      default: variants[0],
      validator: (variant) => variants.includes(variant),
    },
  },
  computed: {
    cssClass() {
      return [`-variant-${this.variant}`];
    },
    imgAttributes() {
      if (!this.img?.attributes) {
        return undefined;
      }

      return {
        alt: '',
        loading: 'lazy',
        src: buildSrc({
          format: 'jpg',
          img: this.img.attributes,
          height: 408,
        }),
        srcset: buildFixedSrcSet({
          format: 'jpg',
          img: this.img.attributes,
          height: 408,
        }),
      };
    },
    sources() {
      if (!this.img?.sources) {
        return undefined;
      }

      return [
        {
          media: MqMinWidthTabletXlarge,
          srcset: buildFixedSrcSet({
            fallback: true,
            format: 'jpg',
            img: this.img.sources,
            height: 293,
          }),
        },
      ];
    },
  },
};
